const PAYMENT_STYLES = {
  paid: "border border-primary text-primary",
  pending: "border border-yellow-500 text-yellow-500",
  inactive: "border text-gray-300 border-gray-300",
};

export function getOrderPaymentStatus(pedido) {
  if (pedido?.cancelado === true) {
    return {
      key: "cancelled",
      label: "",
      style: "",
    };
  }

  if (!pedido?.proveedor?.payments || pedido.require_factura !== true) {
    return {
      key: "not_required",
      label: "No requiere",
      style: PAYMENT_STYLES.inactive,
    };
  }

  if (pedido.pagado === true) {
    return {
      key: "paid",
      label: "Pagado",
      style: PAYMENT_STYLES.paid,
    };
  }

  return {
    key: "pending",
    label: "Pendiente",
    style: PAYMENT_STYLES.pending,
  };
}

export function canPayOrder(pedido) {
  return getOrderPaymentStatus(pedido).key === "pending";
}
